import { useAppDispatch, useAppSelector } from '../store/hooks';
import {
  selectTimeFormat,
  setTimeFormat as setTimeFormatAction,
  type TimeFormat,
} from '../store/slices/preferences.slice';

export interface UseTimeFormat {
  /** Current app-wide time-format preference (defaults to 12h). */
  timeFormat: TimeFormat;
  /** Switch the preference — wired to the future 12/24 settings toggle. */
  setTimeFormat: (format: TimeFormat) => void;
}

/**
 * The time-format seam for UI. Read `timeFormat` and format values with
 * `dateUtils.formatTime(value, timeFormat)` (from `@doccareplus/shared`) so the
 * 12/24 preference flips every time display at once. Pure domain/view helpers
 * that can't use hooks should take `timeFormat` as a parameter instead.
 */
export function useTimeFormat(): UseTimeFormat {
  const timeFormat = useAppSelector(selectTimeFormat);
  const dispatch = useAppDispatch();
  return {
    timeFormat,
    setTimeFormat: (format: TimeFormat) => dispatch(setTimeFormatAction(format)),
  };
}
